module.exports = __webpack_public_path__ + "img/google-maps.0ef4294d.png";